import { lazy } from 'react';

export const CalculationLimited = lazy(() =>
    import('./CalculationLimited').then((module) => ({ default: module.CalculationLimited })),
);
